import TableComponent from "../../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Center } from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { CellProps, Column } from "react-table";
import { primaryColor } from "../../../utils/colors";
import { formatDate } from "../../../helpers/dateUtils";
import FieldOccurencesState from "../../FieldOccurrences/component/FieldOccurencesState";
import AlertSanLevelState from "./AlertSanLevelState";

interface TableOccurrenceAlertSanProps {
  dataTable: any[];
  isLoaded: boolean;
  setValue: (key: string, value: any) => void;
  openModal: (newTitle: string, newButtonTitle: string) => void;
}

const TableOccurrenceAlertSan: FC<TableOccurrenceAlertSanProps> = ({
  dataTable,
  isLoaded,
  setValue,
  openModal,
}) => {
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Id", accessor: "id" },
      {
        Header: "Título",
        accessor: "title",
      },
      {
        Header: "Tipo de Ocorrência",
        accessor: "type.name",
      },
      { Header: "Nível", accessor: "level.name" },
      { Header: "Período", accessor: "dataPeriod.name" },
      { Header: "Ano", accessor: "year" },
      {
        Header: "Criado a:",
        disableSortBy: true,
        accessor: "createdAt",
        Cell: ({ value }: any) => (
          <>{value ? formatDate(new Date(value)) : "-"}</>
        ),
      },
      {
        Header: "Terminado a:",
        disableSortBy: true,
        accessor: "finishedAt",
        Cell: ({ value }: any) => (
          <>{value ? formatDate(new Date(value)) : "-"}</>
        ),
      },
      {
        Header: "Nível do Alerta",
        accessor: "alertSeverity.name",
        Cell: ({ row }: any) => {
          return (
            <AlertSanLevelState
              stateValue={row.original.alertSeverity}
              additionalStyle={{ display: "inline-block" }}
            />
          );
        },
      },
      {
        Header: "Estado",
        accessor: "isActive",
        Cell: ({ row, value }: any) => {
          return (
            <FieldOccurencesState
              stateValue={
                row.original.type?.code?.toLowerCase() === "alertasan"
                  ? value
                  : null
              }
              additionalStyle={{ display: "inline-block" }}
            />
          );
        },
      },
      { Header: "Província", accessor: "province.name", disableSortBy: true },
      {
        Header: "Município",
        accessor: (row: any) => row.county?.name ?? "-",
        disableSortBy: true,
      },
      {
        Header: "Ver Detalhes",
        accessor: "ver",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <ViewIcon
              color={primaryColor}
              boxSize={6}
              mr="8"
              cursor="pointer"
              onClick={() => {
                openModal(
                  `Ver detalhes | Alerta SAN - ${row.original.title}`,
                  "Fechar",
                );
                setValue("row", row.original);
              }}
            />
          </Center>
        ),
      },
    ];
    return baseColumns;
  }, [setValue, openModal]);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "ver", hasShadow: true }]}
    />
  );
};

export default TableOccurrenceAlertSan;
